<template>
  <v-col>
    <v-row>
      <v-autocomplete
        :items="drugstores"
        item-text="name"
        item-value="location"
        placeholder="Drogaria"
        @change="updateDrugstore"
        return-object
        clearable
      />
    </v-row>
    <v-row>
      <GmapMap
        ref="gmap"
        :options="{
          zoomControl: true,
          disableDefaultUi: true
        }"
        :center="{ lat, lng }"
        :zoom="zoom"
        map-type-id="roadmap"
        style="width: 100vw; height: 80vh"
      >
        <GmapMarker
          :key="index"
          :position="position"
          :clickable="true"
          :draggable="true"
        />
        <!-- <gmap-polygon
          v-for="poly in polygons"
          :paths="poly.paths"
          v-bind:key="poly.id"
          :editable="false"
          @paths_changed="updateEdited($event)"
          :options="{
            fillColor: polygonOptions.fillColor,
            fillOpacity: polygonOptions.fillOpacity,
            strokeColor: polygonOptions.strokeColor,
            strokeOpacity: 0.8,
            strokeWeight: 1,
            editable: true
          }"
          ref="polygon"
        ></gmap-polygon> -->
        <GmapPolygon
          v-for="poly in polygons"
          :paths="poly.paths"
          v-bind:key="poly.id"
          :editable="true"
          @paths_changed="updateEdited($event, poly.id)"
          :options="polygonOptions"
          ref="polygon"
        >
        </GmapPolygon>
      </GmapMap>
    </v-row>
  </v-col>
</template>

<script>
import {
  GetAllDrugstores,
  UpdateDeliveryZone
} from "../../graphql/drugstore.gql";

export default {
  data() {
    return {
      index: 0,
      lat: -15.749997,
      lng: -47.9499962,
      zoom: 4,
      id_drugstore: null,
      position: null,
      markers: [{}],
      edited: null,
      paths: [],
      polygons: [],
      polygonsList: {},
      items: [],
      search: null,
      polygonOptions: {
        fillColor: "#0099FF",
        fillOpacity: 0.7,
        strokeColor: "#AA2143",
        strokeWeight: 4,
        editable: true
      }
    };
  },

  apollo: {
    drugstores: {
      query: GetAllDrugstores
    }
  },
  watch: {
    search(val) {
      // Items have already been loaded
      //if (this.drugstores.length > 0) return;

      if (val == null) this.items = this.drugstores;
      if (val != null)
        this.drugstores.filter(item => {
          if (item.name.toLowerCase().indexOf(val.toLowerCase() == 0)) {
            this.items = [item];
          }
        });
    }
  },
  methods: {
    savePolygon(polygon) {
      this.polygons = [];
      this.polygons.push(polygon);
      let bounds = [];
      polygon[0][Object.keys(polygon[0])[0]].map(geo => {
        var point = [geo.lat(), geo.lng()];
        bounds.push(point);
      });
      bounds.push(bounds[0]);
      this.$apollo
        .mutate({
          mutation: UpdateDeliveryZone,
          variables: {
            id_drugstore: this.id_drugstore,
            delivery_zone: {
              type: "Polygon",
              coordinates: [bounds]
            }
          }
        })
        .then(data => {
          let index = this.drugstores.findIndex(
            x => x.id === this.id_drugstore
          );
          this.drugstores[index].delivery_zone =
            data.data.update_drugstores_by_pk.delivery_zone;
          this.updateDrugstore(this.drugstores[index]);
        });
    },
    loadMapDrawingManager() {
      this.polygons = [];
      let self = this;
      this.$gmapApiPromiseLazy().then(() => {
        // eslint-disable-next-line no-unused-vars

        // eslint-disable-next-line no-undef
        const drawingManager = new google.maps.drawing.DrawingManager({
          drawingControl: true,
          drawingControlOptions: {
            // eslint-disable-next-line no-undef
            position: google.maps.ControlPosition.TOP_CENTER,
            // eslint-disable-next-line no-undef
            drawingModes: [google.maps.drawing.OverlayType.POLYGON]
          },
          polygonOptions: {
            fillColor: "#0099FF",
            fillOpacity: 0.7,
            strokeColor: "#AA2143",
            strokeWeight: 4,
            editable: true
          }
        });
        drawingManager.setMap(self.$refs.gmap.$mapObject);

        // eslint-disable-next-line no-undef
        google.maps.event.addListener(
          drawingManager,
          "overlaycomplete",
          function(event) {
            // Get overlay paths
            let paths = event.overlay.getPaths().getArray();
            // Remove overlay from map
            event.overlay.setMap(null);

            // Disable drawingManager
            // drawingManager.setDrawingMode(null);

            // Create Polygon
            self.savePolygon(paths);
          }
        );
      });
    },
    updateEdited(paths) {
      this.savePolygon(paths[Object.keys(paths)[0]]);
      /* this.loadPolygons(); */
    },
    showDescPolygon(x, y) {
      console.log(x, y);
    },
    loadPolygons() {
      if (this.polygons != null && this.polygons.length > 0) {
        let bounds = [];
        this.polygons[0][0][Object.keys(this.polygons[0][0])[0]].map(geo => {
          var point = [geo.lat(), geo.lng()];
          bounds.push(point);
        });
        this.polygons = [];

        this.polygons.push({ id: this.id_drugstore, paths: bounds });
      }
    },
    updateDrugstore(value) {
      this.polygons = [];
      let position = value.location
        .replace("(", "")
        .replace(")", "")
        .split(",");

      let bounds = [];

      this.id_drugstore = value.id;

      if (value.delivery_zone != null) {
        value.delivery_zone.coordinates[0].map(geo => {
          var point = {
            lat: geo[0],
            lng: geo[1]
          };
          bounds.push(point);
        });

        this.polygons.push({ id: this.id_drugstore, paths: bounds });
      }

      this.lat = Number(position[0]);
      this.lng = Number(position[1]);

      // eslint-disable-next-line no-undef
      this.position = new google.maps.LatLng(this.lat, this.lng);

      this.zoom = 14;
    }
  },
  created() {
    this.items = this.drugstores;
  },
  mounted() {
    this.items = this.drugstores;
    this.loadMapDrawingManager();
    //this.loadControls();
  }
};
</script>

<style></style>
